export const formatCurrency = value => {
  if (value === null || value === undefined) return '-';
  return Number(value).toLocaleString('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

export const formatVariancePercent = value => {
  if (value === null || value === undefined) return '-';
  return `${Number(value).toLocaleString('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}%`;
};
